// router.js
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      meta:{
        showTitle: true
      },
      component: () => import('../views/HomePage.vue')
    },
    {
      path: '/home',
      name: 'home',
      meta:{
        showTitle: true
      },
      component: () => import('../views/HomePage.vue')
    },
    {
      path: '/clausesView',
      name: 'clausesView',
      component: () => import('../views/ClausesPage.vue')
    },
    {
      path: '/paymentAgreement',
      name: 'paymentAgreement',
      component: () => import('../views/PaymentAgreement.vue')
    },
    {
      path: '/renewalAgreement',
      name: 'renewalAgreement',
      component: () => import('../views/RenewalAgreement.vue')
    },
    {
      path: '/Statement',
      name: 'Statement',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/StatementPage.vue')
    }
  ]
});

export default router;